export default {
  "name": "NCSteps",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCSteps",
  "label": "步骤条",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "current": {
        "title": "设置当前步骤",
        "description": "设置当前步骤",
        "type": "number",
        "default": 0
      },
      "size": {
        "title": "step bar的大小",
        "description": "step bar的大小",
        "type": "string"
      },
      "direction": {
        "title": "方向",
        "description": "方向",
        "enumNames": [
          "水平",
          "垂直"
        ],
        "type": "enum",
        "enum": [
          "horizontal",
          "vertical"
        ]
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}